'use strict';
/**
 * @author Maxim Seredkin
 */
// angular
import angular from 'angular';
import country from './module/country';
import industry from './module/industry';
import investorCountry from './module/investor_country';
import landCategory from './module/land_category';
import okved from './module/okved';
import okvedMulti from './module/okved_multi';
import pstatus from './module/pstatus';
import srcCategory from './module/src_category';
import area from './module/area';
import unit from './module/unit';
import supportStage from './module/support_stage';

export default angular.module('investmentProject.enchiridion.classifier',
    [country, industry, investorCountry, landCategory, okved, okvedMulti, pstatus, srcCategory, area, unit, supportStage])
    .name;

